import { Flex, Box } from '@chakra-ui/react';
import { TimePicker } from 'Deer/components/common/TimePicker';
import { useDispatch } from 'react-redux';

import { DatePicker } from 'uiToolkitV1/DatePicker';
import { TextLabel } from 'uiToolkitV1/Typography';

import { updateAddViolationDrawer, useSelectAddViolationDrawerData } from '../slice/addViolation.slice';

const DateAndTimeDropdown = () => {
  const { reportedTime } = useSelectAddViolationDrawerData();
  const dispatch = useDispatch();

  const handleReportedDateTimeChange = (newDate: Date) => {
    dispatch(
      updateAddViolationDrawer({
        reportedTime: newDate,
      })
    );
  };

  return (
    <Box>
      <TextLabel color="text.g2">Date & time</TextLabel>
      <Flex gap={3} mb={4}>
        <Box
          w="100%"
          sx={{
            '& .mesh-date-picker-button': {
              width: '100%',
            },
            '& .react-datepicker-wrapper': {
              width: '100%',
            },
          }}
        >
          <DatePicker popperPlacement="auto" selectedDate={reportedTime} onChange={handleReportedDateTimeChange} />
        </Box>
        <Box w="100%">
          <TimePicker time={reportedTime} onTimeUpdate={handleReportedDateTimeChange} />
        </Box>
      </Flex>
    </Box>
  );
};

export { DateAndTimeDropdown };
